<template>
  <v-flex xs12>
    <v-card>
      <v-data-table
        :loading="loader"
        disable-initial-sort
        :headers="headers"
        :search="search"
        :items="items"
        item-key="_id || building"
        :rows-per-page-items="rowPerPage"
      >
        <template #items="props">
          <tr>
            <td class="text-no-wrap">
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon small color="#464D69">settings</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile
                            @click="selected_bill = props.item; trigger_edit_component = !trigger_edit_component;"
                        >
                            <v-list-tile-action>
                                <v-icon small class="zmdi zmdi-edit"></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                Chỉnh sửa
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </td>
            <td class="text-no-wrap">{{ BUILDING_DISPLAY_MAPPING[props.item.building] }}</td>
            <td class="text-no-wrap">{{ props.item.description }}</td>
            <td>{{ props.item.start }}</td>
            <td>{{ props.item.end }}</td>
            <td>{{ props.item.start_after_change_counter }}</td>
            <td>{{ props.item.end_after_change_counter }}</td>
            <td>{{ props.item.consumption }}</td>
            <td>{{ props.item.note }}</td>
          </tr>
        </template>
        <template #no-data>
          Chưa có thông tin
        </template>
      </v-data-table>
    </v-card>
    <dialog-cap-nhat-dien-nuoc-noi-bo
        :bill="selected_bill"
        :dialog="trigger_edit_component"
        @changeDialogState="trigger_edit_component = $event"
        @getData="getData()"
    />
  </v-flex>
</template>

<script>
import { buildParamQuery, formatTimeServer, dayDiff, deepCopy } from "Helpers";
import { CONSUMERS_BY_CONSUMER_TYPE, BUILDING_DISPLAY_MAPPING } from "Constants/db-config";
import api from "Api";
import DialogCapNhatDienNuocNoiBo from './DialogCapNhatDienNuocNoiBo';

export default {
  name: "table-nhap-dien-nuoc-noi-bo",
  props: {
    type: String,
    consumer_type: String,
    chosen_month: String,
  },
  components: {
    DialogCapNhatDienNuocNoiBo,
  },
  data() {
    return {
      headers: [
        { text: "Thao tác", align: "left", sortable: true, value: "_id" },
        { text: "Tòa nhà", align: "left", sortable: true, value: "building" },
        { text: "Diễn giải", align: "left", sortable: true, value: "description" },
        { text: "Đầu Kì", align: "left", sortable: true, value: "start" },
        { text: "Cuối Kì", align: "left", sortable: true, value: "end" },
        {
          text: "Đầu Kì Sau TĐH",
          align: "left",
          sortable: true,
          value: "start_after_change_counter",
        },
        {
          text: "Cuối Kì Sau TĐH",
          align: "left",
          sortable: true,
          value: "end_after_change_counter",
        },
        {
          text: "Tiêu Thụ",
          align: "left",
          sortable: true,
          value: "consumption",
        },
        { text: "Ghi Chú", align: "center", sortable: true, value: "note" },
      ],
      items: [],
      loader: false,
      rowPerPage: [50],
      list_consumer: CONSUMERS_BY_CONSUMER_TYPE[this.consumer_type],
      selected_bill: {},
      trigger_edit_component: false,
      BUILDING_DISPLAY_MAPPING,
    };
  },
  watch: {
    chosen_month: {
      handler: function(nv) {
        this.getData();
      },
      immediate: true,
    },
    type() {
      this.getData();
    },
  },
  created() {},
  methods: {
    async getData() {
      this.items = [];
      const params = {
          month: this.chosen_month,
          type: this.type,
          consumerType: this.consumer_type,
      }

      const query = buildParamQuery(params)
      this.loader  = true;
      const data = await api.getListInternalUtilityBills(query);
      this.loader  = false;
      this.items = this.list_consumer.map((consumer) => {
        const found = data.data.find((bill) => bill.building === consumer.building && bill.consumer === consumer.consumer);

        if (found) {
            return {
              ...found,
              description: consumer.description,
            }
        } else {
            return {
                ...consumer,
                type: this.type,
                consumer_type: this.consumer_type,
                month: this.chosen_month,
            }
        }
      })
    },
  },
};
</script>
